import React from 'react';
import AppDownload from '../pages/AppDownload';

/**
 * Fallback for universal links when the app is not installed.
 * The download screen owns the Smart App Banner and the install handoff.
 */
const UniversalLinkHandler = () => <AppDownload />;

export default UniversalLinkHandler;
